<template>
  <a
    v-translate
    :href="signUpUrl"
    :class="$style.container"
  >register</a>
</template>

<script>
  export default {
    props: {
      signUpUrl: {
        type: String
      }
    },
    locales: {
      'en': {
        'register': 'Registration'
      },
      'ru': {
        'register': 'Регистрация'
      }
    }
  }
</script>

<style lang="scss" module>
  @import "~@stylesheets/includes/mixins";
  @import "~@stylesheets/common/buttons/button-b";

  /**
   * DESKTOP
   */
  @include desktop {
    /**
     * Container
     */
    .container {
      @include button-b1;
      min-width: 170px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RegisterButton.vue